import { render, staticRenderFns } from "./SignGiftList.vue?vue&type=template&id=303083be"
import script from "./SignGiftList.vue?vue&type=script&lang=js"
export * from "./SignGiftList.vue?vue&type=script&lang=js"
import style0 from "./SignGiftList.vue?vue&type=style&index=0&id=303083be&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports